import { render } from "./ApprovalStart.vue?vue&type=template&id=29023c41&scoped=true&ts=true"
import script from "./ApprovalStart.vue?vue&type=script&lang=ts"
export * from "./ApprovalStart.vue?vue&type=script&lang=ts"

import "./ApprovalStart.vue?vue&type=style&index=0&id=29023c41&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29023c41"]])

export default __exports__